import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AdminAccessService } from '../admin-access.service';
import { AuthService } from '../auth.service';
import { OrdersLoginGuardGuard } from './orders-login-guard.guard';

@Injectable({
  providedIn: 'root'
})
export class OrdersPanalGuardGuard implements CanActivate {
  
  constructor(private adminAccess: AdminAccessService,private auth:AuthService,private router:Router, private guard:OrdersLoginGuardGuard){}
  
  al3alia:string="al3aliacontrolpanal2020@admin.com"
  
  yaqot:string="alyaqotcontrolpanal2020@admin.com"

  basten:string="albasatencontrolpanal2020@admin.com"

  general:string = "controlpanel2020@admin.com"

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot ):boolean | Observable<boolean> | Promise<boolean> {
  
    return new Promise(resolve => {
  
    // this.adminAccess.getAccess().subscribe(data=>{

    //   if (data.length !=1)resolve(false)

    //   else resolve(true)

    // })

    this.auth.user.subscribe(user => {

      if ( user && user.email == this.al3alia || user && user.email == this.general || user && user.email == this.basten || user && user.email == this.yaqot ) {

        resolve(true)
              
      }
  
    //  else if (user)
    //    {
      
    //      resolve(false)

    //      this.router.navigate(['/must-logout'])      
    //    } 

      else {
  
        resolve(false)

        this.router.navigate(['/controls-panel-login'])


      } 
   

    })
   
  })

  }
  
}
